// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const sinistcha: PokeData = {
  "id": 1013,
  "name": "sinistcha",
  "height": 2,
  "weight": 22,
  "base_experience": 178,
  "types": [
    PokeType.GRASS,
    PokeType.GHOST
  ],
  "api_moves": [
    "absorb",
    "mega-drain",
    "stun-spore",
    "withdraw",
    "shadow-ball",
    "memento",
    "astonish",
    "leaf-storm",
    "rage-powder",
    "foul-play",
    "hex",
    "strength-sap",
    "life-dew",
    "matcha-gotcha"
  ],
  "moves": [
    "stun-spore",
    "shadow-ball",
    "life-dew",
    "bullet-seed",
    "leaf-tornado",
    "razor-leaf",
    "lick",
    "aromatherapy",
    "spectral-chain",
    "poltergeist",
    "energy-ball",
    "grassy-terrain",
    "power-whip"
  ],
  "evolution_chain": {
    "id": 539,
    "item": null,
    "species": [
      {
        "name": "poltchageist",
        "order": 1014,
        "types": [
          PokeType.GRASS,
          PokeType.GHOST
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "sinistcha",
        "order": 1015,
        "types": [
          PokeType.GRASS,
          PokeType.GHOST
        ],
        "evolves_from_species_id": 1012,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 120,
    "speed": 103,
    "ability_power": 177
  },
  "stat_changes": [],
  "catch_rate": 60,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
